module.exports = __webpack_public_path__ + "static/img/top05.3f70b18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/TW/img/top05.png
// module id = 3I/v
// module chunks = 1